import { Link } from 'react-router-dom'

export default function Privacidad() {
  return (
    <div style={S.page}>
      <div style={S.inner}>
        <div style={S.backRow}>
          <Link to="/" style={S.back}>← Volver al inicio</Link>
        </div>

        <h1 style={S.h1}>Política de Privacidad</h1>
        <p style={S.meta}>Última actualización: mayo 2026 · Qapaq SpA · RUT 78.415.721-0</p>

        <Section title="1. Responsable del tratamiento">
          <p>Qapaq SpA (RUT 78.415.721-0), domicilio en Hijuelas, V Región, Chile.
          Contacto DPO: <a href="mailto:legal@qapaq.cl">legal@qapaq.cl</a></p>
        </Section>

        <Section title="2. Datos que recopilamos">
          <ul>
            <li><strong>Registro:</strong> nombre, RUT, correo electrónico, teléfono, rol (oferente / transportista).</li>
            <li><strong>Operación:</strong> origen/destino de cargas, historial de envíos, calificaciones, documentos tributarios.</li>
            <li><strong>Vehículos:</strong> patente, tipo, documentación del vehículo (solo Transportistas).</li>
            <li><strong>Ubicación GPS:</strong> posición del vehículo durante envíos activos (solo Transportistas).</li>
            <li><strong>Comunicaciones:</strong> mensajes de chat interno y WhatsApp Business de soporte.</li>
            <li><strong>Técnicos:</strong> dirección IP, tipo de dispositivo, logs de acceso.</li>
          </ul>
        </Section>

        <Section title="3. Finalidad y base legal">
          <ul>
            <li>Ejecución del contrato de intermediación logística.</li>
            <li>Cumplimiento de obligaciones tributarias (SII) y normativa de transporte.</li>
            <li>Seguridad, prevención de fraude y verificación de identidad.</li>
            <li>Mejora continua del servicio y análisis estadístico interno.</li>
            <li>Comunicaciones de servicio (notificaciones de envío, alertas de remate).</li>
          </ul>
        </Section>

        <Section title="4. Compartición de datos">
          <p>Qapaq no vende ni cede datos personales a terceros con fines comerciales. Puede compartir
          datos estrictamente necesarios con:</p>
          <ul>
            <li>Otros usuarios de la plataforma (nombre, teléfono de contacto para el envío en curso).</li>
            <li>Proveedores de servicios técnicos bajo acuerdo de confidencialidad (Supabase, Vercel).</li>
            <li>Autoridades competentes cuando sea requerido por ley.</li>
            <li>Compañía aseguradora, para gestión de siniestros.</li>
          </ul>
        </Section>

        <Section title="5. Retención de datos">
          <p>Los datos se conservan mientras la cuenta esté activa y por el período mínimo exigido por
          la normativa tributaria (6 años para documentos SII) y la Ley 19.496 de Protección al Consumidor.</p>
        </Section>

        <Section title="6. Derechos del titular">
          <p>Conforme a la Ley 19.628 (y sus modificaciones vigentes), usted tiene derecho a:</p>
          <ul>
            <li>Acceder a sus datos personales.</li>
            <li>Rectificar datos inexactos o desactualizados.</li>
            <li>Solicitar la eliminación de sus datos (derecho al olvido), salvo obligaciones legales.</li>
            <li>Oponerse al tratamiento para fines de marketing directo.</li>
          </ul>
          <p>Ejerza sus derechos escribiendo a <a href="mailto:legal@qapaq.cl">legal@qapaq.cl</a> con asunto «Derechos ARCO».</p>
        </Section>

        <Section title="7. Seguridad">
          <p>Qapaq aplica medidas técnicas y organizativas adecuadas para proteger sus datos:
          cifrado en tránsito (TLS), cifrado en reposo, acceso con principio de mínimo privilegio
          y autenticación de dos factores para accesos administrativos.</p>
        </Section>

        <Section title="8. Cookies y rastreo">
          <p>La plataforma utiliza cookies de sesión estrictamente necesarias para la autenticación.
          No se utilizan cookies de seguimiento publicitario de terceros en el área autenticada.</p>
          <p>La página pública (qapaq.cl) puede utilizar cookies analíticas básicas. Puede deshabilitarlas
          desde la configuración de su navegador.</p>
        </Section>

        <Section title="9. Cambios a esta política">
          <p>Cualquier modificación relevante será notificada por correo electrónico con al menos
          10 días de anticipación.</p>
        </Section>

        <div style={S.contacto}>
          <p>Consultas de privacidad: <a href="mailto:legal@qapaq.cl">legal@qapaq.cl</a></p>
        </div>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section style={S.section}>
      <h2 style={S.h2}>{title}</h2>
      <div style={S.body}>{children}</div>
    </section>
  )
}

const S = {
  page: {
    minHeight: '100vh',
    background: '#F9F9F9',
    padding: '2rem 1rem 4rem',
    fontFamily: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
  },
  inner: {
    maxWidth: 780,
    margin: '0 auto',
  },
  backRow: {
    marginBottom: '1.5rem',
  },
  back: {
    color: '#FF5A00',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 600,
  },
  h1: {
    fontSize: 'clamp(1.5rem, 3vw, 2rem)',
    fontWeight: 800,
    color: '#111111',
    margin: '0 0 0.5rem',
  },
  meta: {
    fontSize: '0.82rem',
    color: '#888',
    marginBottom: '2.5rem',
  },
  section: {
    marginBottom: '2rem',
    borderBottom: '1px solid #E8E8E8',
    paddingBottom: '1.5rem',
  },
  h2: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#FF5A00',
    marginBottom: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
  },
  body: {
    fontSize: '0.92rem',
    color: '#333',
    lineHeight: 1.7,
  },
  contacto: {
    marginTop: '2.5rem',
    fontSize: '0.88rem',
    color: '#555',
    textAlign: 'center',
  },
}
